import { useEffect, useState } from "react";
import api from "@/lib/apiClient";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { ShieldCheck } from "lucide-react";

export default function RolesTab() {
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    api.get("/roles").then(({ data }) => setRoles(data || []));
  }, []);

  const permLabel = (perms) => (perms?.includes("*") ? "All permissions" : `${perms?.length || 0} permissions`);

  return (
    <div data-testid="roles-tab">
      <div className="mb-4">
        <h3 className="font-display text-lg font-semibold text-secondary">Roles &amp; Permissions</h3>
        <p className="text-sm text-muted-foreground">System roles (read-only). Editing custom roles arrives in a later phase.</p>
      </div>

      <div className="rounded-xl border border-border bg-card">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Role</TableHead><TableHead>Description</TableHead>
              <TableHead>Level</TableHead><TableHead>Permissions</TableHead><TableHead>Users</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {roles.map((r) => (
              <TableRow key={r.id} data-testid={`role-row-${r.name.replace(/\s+/g, "-").toLowerCase()}`}>
                <TableCell className="flex items-center gap-2 font-medium text-secondary">
                  <ShieldCheck className="h-4 w-4 text-primary" />{r.name}
                  {r.is_system && <Badge className="border-0 bg-slate-100 text-[10px] text-slate-500">SYSTEM</Badge>}
                </TableCell>
                <TableCell className="text-sm text-muted-foreground">{r.description}</TableCell>
                <TableCell>{r.level}</TableCell>
                <TableCell><Badge className="border-0 bg-primary/10 text-primary">{permLabel(r.permissions)}</Badge></TableCell>
                <TableCell>{r.user_count}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
